import { render } from "./VerifyMeButton.vue?vue&type=template&id=bf2f571a&ts=true"
import script from "./VerifyMeButton.vue?vue&type=script&lang=ts"
export * from "./VerifyMeButton.vue?vue&type=script&lang=ts"

import "./VerifyMeButton.vue?vue&type=style&index=0&id=bf2f571a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__